import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import useCancellationToken from 'utils/customHook/useCancellationToken';
import { customAxiosGetFunction, customAxiosPostFunction } from 'utils/axiosFunction';
import SearchDate from './SearchDate';
import SearchModule from './SearchModule';
import SearchPeriod from './SearchPeriod';

import { SearchBarConatiner } from './GasExcelSearchBar.css.js';

const GasExcelSearchBar = ({ searchMap, setSearchMap }) => {
  const history = useHistory();
  const [dateValid, setDateValid] = useState(true);
  const cancellationToken = useCancellationToken();
  const updateSearchMap = useCallback(
    (key, value) => {
      if (cancellationToken.isCancelled) {
        return;
      }

      setSearchMap((searchMap) => {
        return {
          ...searchMap,
          [key]: value,
        };
      });
    },
    [searchMap, cancellationToken]
  );

  const excelDownload = () => {
    const beginDate = moment(searchMap.beginDate).format('YYYY-MM-DD HH:mm:ss');
    const endDate = moment(searchMap.endDate).format('YYYY-MM-DD HH:mm:ss');

    axios
      .post('/api/gas/excel/down', { moduleIdx: searchMap.moduleIdx, beginDate, endDate }, { responseType: 'blob' })
      .then((response) => {
        const fileName = `UBiTOMS™ 레포트_${moment().format('YYYYMMDD')}.xlsx`;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => () => cancellationToken.cancel(), []);

  return (
    <SearchBarConatiner>
      <div className="form-row">
        <SearchPeriod updateSearchMap={updateSearchMap} setDateValid={setDateValid} />
        <SearchModule updateSearchMap={updateSearchMap} />
        <button className="btn btn-info" onClick={excelDownload}>
          다운로드
        </button>
      </div>
      <div className="form-row">
        <SearchDate title="시작날짜" dateValid={dateValid} updateSearchMap={updateSearchMap} name="beginDate" />
        <SearchDate title="종료날짜" dateValid={dateValid} updateSearchMap={updateSearchMap} name="endDate" />
      </div>
    </SearchBarConatiner>
  );
};

export default React.memo(GasExcelSearchBar);
